import { toastMessage } from './toast';
import * as userAuthActions from '../../Redux/Actions/user';

export const validationError = (error) => {
    let validationErrs = error.data.data.validations;
    return validationErrs && validationErrs.map(validationErr => toastMessage('error', validationErr));
};

export  const clearSession = (dispatch, history) => {
    dispatch(userAuthActions.userAuthLogout());
    localStorage.removeItem('jwt');
    history.push('/');
};